module.exports = __webpack_public_path__ + "static/Compu1-2879519d3165db1fe15a343b78c53db6.png";